import { Col, Container, Row } from "react-bootstrap";
import profileImage from "../assets/img/about me.jpg";

export const About = () => {
  return (
    <section className="about" id="about">
      <Container style={{ paddingTop: "50px", paddingBottom: "50px" }}>
        <h1>About</h1>
        <Row className="align-items-center">
          <Col xs={12} lg={8} xl={7}>
            <div className="about-text">
              <h4 className="about-headline">
                {"user@:~$ "}
                <span>who am I ?</span>
              </h4>
              <hr />
              <div className="about-body">
                <p>
                  Mein Haupteinsatzbereich während der Arbeit und in der
                  Freizeit ist:{" "}
                  <span className="about-highlight">die Web-Entwicklung</span>,
                  insbesondere das Arbeiten mit{" "}
                  <span className="about-highlight">Javascript und React </span>
                  hat meine Leidenschaft für die Entwicklung von Webanwendungen
                  geweckt.
                </p>
                <br />
                <p>
                  Ich fühle mich besonders wohl in der{" "}
                  <span className="about-highlight">Frontend Entwicklung</span>,
                  dort ist Kreativität sehr wichtig, nicht nur bei der
                  Problemlösung, sondern auch beim Entwerfen und{" "}
                  <span className="about-highlight">
                    Erstellen von Benutzeroberflächen, welche ausschlaggebend
                    für eine gute Benutzererfahrung sind
                  </span>
                  . Ich liebe den Prozess vom{" "}
                  <span className="about-highlight">
                    Entwurf bis hin zur Umsetzung.{" "}
                  </span>
                  Das Beste daran ist jedoch, wenn man nach harter Arbeit das
                  Ergebnis sieht und es für etwas Sinnvolles nutzen kann.
                </p>
                <br />
                <p>
                  In meiner Freizeit probiere ich gerne Neues aus, bin kreativ
                  tätig und erweitere so oft wie möglich meinen Horizont. Eines
                  meiner Hobbys verbindet, ähnlich wie das Programmieren, das
                  Kreative wie auch das Technische:{" "}
                  <span className="about-highlight">
                    Die Fotografie und Bildbearbeitung
                  </span>
                  .
                </p>
                <div className="about-quote">
                  <p>
                    ✨Es fasziniert mich immer wieder, was man mit Hilfe von
                    Daten und Code alles erschaffen kann, um damit z.B. den
                    Alltag oder Prozesse zu vereinfachen✨
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} lg={4} xl={5} className="about-image-col">
            <div className="about-image-frame">
              <img src={profileImage} alt="Luca Liam Schäfer" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
